import { useEffect } from "react";
import "./termsandcondition.css";

const TermsAndCondition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      title: "1. OBJETO Y ALCANCE",
      body: (
        <>
          <p>
            Los presentes Términos y Condiciones (en adelante, los “Términos”)
            regulan el acceso, navegación y uso de la Plataforma Ticketera ZOCO
            (en adelante, la “Plataforma”), propiedad de ZOCO S.A.S. (en
            adelante, “ZOCO”), a través de la cual los usuarios pueden adquirir
            entradas para eventos, espectáculos o actividades organizadas por
            terceros independientes (en adelante, los “Organizadores” y/o
            “Productores”).
          </p>
          <p>
            ZOCO actúa como intermediario tecnológico y proveedor de servicios
            de cobro y emisión de entradas, por cuenta y orden de los
            Organizadores.
          </p>
          <p>
            ZOCO no organiza, produce, patrocina ni administra los eventos, ni
            asume responsabilidad alguna por su realización, contenido,
            cancelación o condiciones de seguridad.
          </p>
        </>
      ),
    },
    {
      title: "2. ACEPTACIÓN DE LOS TÉRMINOS",
      body: (
        <>
          <p>
            El acceso o uso de la Plataforma implica la plena aceptación de
            estos Términos y Condiciones.
          </p>
          <p>
            El usuario que no esté de acuerdo con los mismos deberá abstenerse
            de utilizar la Plataforma y sus servicios.
          </p>
          <p>
            Solo podrán utilizar los servicios de la Plataforma las personas
            humanas mayores de 18 (dieciocho) años o las personas jurídicas que
            tengan capacidad legal para contratar y realizar compras conforme a
            la legislación vigente.
          </p>
          <p>
            El uso por parte de menores de edad o de quienes carezcan de
            capacidad legal se encuentra prohibido.
          </p>
          <p>
            En caso de verificarse operaciones realizadas por personas sin dicha
            capacidad, ZOCO podrá anular la cuenta o la transacción
            correspondiente, reservándose el derecho de comunicar la situación
            al titular legítimo del medio de pago o a las autoridades
            competentes.
          </p>
        </>
      ),
    },
    {
      title: "3. SERVICIO DE INTERMEDIACIÓN",
      body: (
        <>
          <p>
            ZOCO pone a disposición de los Organizadores una plataforma
            tecnológica (en adelante, la “Plataforma”) que les permite, de
            manera integral:
          </p>
          <ul>
            <li>
              publicar y difundir eventos, tanto gratuitos como arancelados, así
              como habilitar la disponibilidad de entradas;
            </li>
            <li>
              gestionar el proceso de emisión de entradas digitales identificadas
              mediante códigos QR únicos; y
            </li>
            <li>
              en el caso de eventos arancelados, gestionar el proceso de
              comercialización, incluyendo la venta y el cobro de entradas, así
              como la administración y liquidación de los fondos percibidos por
              cuenta y orden del Organizador, con deducción de los cargos de
              servicio, comisiones e impuestos aplicables conforme la normativa
              vigente y las condiciones contractuales pactadas.
            </li>
          </ul>
          <p>
            En los eventos de carácter gratuito, ZOCO se limita a proveer la
            herramienta de registro, emisión y validación de entradas, no
            interviniendo en operación de cobro alguna.
          </p>
          <p>
            Las personas que acceden a la Plataforma para obtener entradas (en
            adelante, los “Consumidores”) lo hacen con el exclusivo fin de
            adquirir o reservar accesos a eventos organizados por terceros, ya
            sean gratuitos o arancelados.
          </p>
          <p>
            El vínculo jurídico relativo al acceso al evento, sea a título
            oneroso o gratuito, se configura directa y exclusivamente entre el
            Consumidor y el Organizador, quien resulta el único responsable por
            la organización, realización, condiciones, características, cupo,
            acceso y eventual cancelación, reprogramación o modificación del
            evento.
          </p>
          <p>
            En este marco, ZOCO actúa exclusivamente como proveedor de servicios
            tecnológicos y, cuando corresponda, como intermediario en la gestión
            de cobros por cuenta y orden del Organizador, no asumiendo en ningún
            caso el carácter de organizador, proveedor directo del evento ni
            garante del mismo.
          </p>
        </>
      ),
    },
    {
      title: "4. RELACIÓN ENTRE LAS PARTES",
      body: (
        <>
          <ul>
            <li>
              <strong>ZOCO S.A.S.:</strong> actúa como proveedor de servicios
              tecnológicos, facilitando una plataforma de intermediación para la
              publicación de eventos y, en su caso, la gestión de cobros por
              cuenta y orden de los Organizadores, sin intervenir en la
              producción, organización, ejecución ni en el contenido de los
              eventos.
            </li>
            <li>
              <strong>Organizadores y/o Patrocinadores:</strong> son los únicos y
              exclusivos responsables por los eventos que publican en la
              Plataforma, incluyendo su organización, condiciones de acceso,
              habilitaciones, seguridad, contenido, información difundida, así
              como cualquier modificación, reprogramación, cancelación,
              devoluciones y/o reembolsos que pudieran corresponder.
            </li>
            <li>
              <strong>Consumidores:</strong> acceden a la Plataforma con el fin de
              adquirir o reservar entradas para eventos organizados por terceros,
              siendo de su exclusiva responsabilidad verificar, con carácter
              previo, las condiciones del evento, incluyendo, en su caso, precio,
              fecha, horario, ubicación y demás características relevantes.
            </li>
          </ul>
          <p>
            El vínculo jurídico relativo al acceso al evento, sea a título
            oneroso o gratuito, se configura directa y exclusivamente entre el
            Consumidor y el Organizador, no siendo ZOCO parte en dicha relación
            contractual.
          </p>
          <p>
            En consecuencia, ZOCO no asume obligación ni responsabilidad alguna
            respecto de la realización del evento, ni garantiza su cumplimiento,
            calidad, seguridad, legalidad o adecuación a las expectativas del
            Consumidor.
          </p>
        </>
      ),
    },
    {
      title: "5. CONDICIONES DE ADQUISICIÓN DE ENTRADAS",
      body: (
        <>
          <p>
            Las entradas, ya sean adquiridas a título oneroso o reservadas en
            forma gratuita, se gestionan por cuenta y orden del Organizador,
            quien es el único responsable de la organización, producción y
            ejecución del evento.
          </p>
          <p>
            Previo a confirmar la adquisición de entrada, el Consumidor deberá
            revisar cuidadosamente:
          </p>
          <ul>
            <li>la descripción y condiciones del evento;</li>
            <li>
              los precios, en su caso, fechas, horarios, ubicaciones y cargos de
              servicio aplicables;
            </li>
            <li>las condiciones de entrega y validez de la entrada digital;</li>
            <li>
              las condiciones de acceso, permanencia y seguridad establecidas por
              el Organizador.
            </li>
          </ul>
          <p>
            Al adquirir una entrada, el Consumidor acepta que las condiciones de
            acceso y permanencia en el evento serán determinadas exclusivamente
            por el Organizador, quien podrá establecer medidas de seguridad,
            controles de identidad, validación de tickets, inspecciones
            preventivas y demás disposiciones operativas.
          </p>
          <p>
            A título meramente enunciativo, el Organizador podrá prohibir el
            ingreso de determinados objetos o elementos, tales como pirotecnia,
            dispositivos de grabación profesional, cámaras fotográficas o de
            video, sustancias prohibidas, bebidas o productos no autorizados u
            otros artículos que pudieran resultar peligrosos o incompatibles con
            el evento, quedando dicha determinación sujeta a su exclusivo
            criterio y a la normativa aplicable. Asimismo, podrá ejercer el
            derecho de admisión y permanencia conforme la legislación vigente, así
            como regular el ingreso en caso de llegadas tardías.
          </p>
          <p>
            En el caso de eventos arancelados, una vez confirmada la operación,
            no se admitirán cambios ni devoluciones, salvo en los supuestos
            previstos en el punto 9 (Derecho de Arrepentimiento) o cuando el
            evento sea cancelado o reprogramado por el Organizador, quien deberá
            informar las condiciones aplicables y el procedimiento para la
            gestión de eventuales devoluciones.
          </p>
        </>
      ),
    },
    {
      title: "6. PROCESO DE PAGO Y SEGURIDAD",
      body: (
        <>
          <p>
            En los casos de eventos arancelados, los pagos son procesados a
            través de servicios de cobro electrónico seguros, provistos por
            entidades autorizadas, que cumplen con estándares internacionales de
            seguridad, incluyendo certificación PCI DSS (Payment Card Industry
            Data Security Standard), y mecanismos de autenticación reforzada como
            el protocolo 3D Secure (3DS), destinado a validar la identidad del
            titular del medio de pago ante la entidad emisora.
          </p>
          <p>
            ZOCO no almacena ni accede a datos sensibles vinculados a los
            instrumentos de pago utilizados por los Consumidores. Dichos datos
            son tratados exclusivamente por el proveedor de servicios de pago
            autorizado, mediante el uso de tecnologías de cifrado y tokenización
            que resguardan la confidencialidad de la información.
          </p>
        </>
      ),
    },
    {
      title: "7. ENTREGA DE ENTRADAS",
      body: (
        <>
          <p>
            Una vez acreditado el pago, o confirmada la reserva en el caso de
            eventos gratuitos, ZOCO emitirá una entrada digital única,
            identificada mediante un código QR, que será enviada al correo
            electrónico informado por el Consumidor y quedará asimismo disponible
            en su cuenta dentro de la Plataforma, para su consulta, descarga o
            visualización mediante el acceso con sus credenciales.
          </p>
          <p>
            El ingreso al evento requerirá la presentación de la entrada digital,
            ya sea en formato electrónico desde un dispositivo móvil o en soporte
            impreso, pudiendo el Organizador exigir, cuando lo considere
            necesario, la acreditación de identidad mediante la exhibición de
            Documento Nacional de Identidad (DNI) u otra documentación válida. En
            caso de optarse por la impresión física, la disponibilidad para
            descarga e impresión de la entrada podrá habilitarse dentro de las
            doce (12) horas previas al inicio del evento, conforme la
            configuración operativa definida por el Organizador.
          </p>
          <p>
            Cada entrada cuenta con un código QR único, válido para un (1) solo
            ingreso. Una vez validado, el código quedará automáticamente
            inhabilitado, no permitiéndose su reutilización.
          </p>
          <p>
            En caso de detectarse duplicación, copia, falsificación, uso indebido
            o cualquier intento de fraude respecto del código QR, el Organizador
            podrá denegar el ingreso, prevaleciendo en todos los casos el primer
            acceso registrado como válido.
          </p>
          <p>
            El Consumidor es el único responsable por la custodia, uso adecuado y
            confidencialidad de la entrada. ZOCO no será responsable por la
            pérdida, robo, copia o utilización indebida de la misma por parte de
            terceros.
          </p>
          <p>
            Asimismo, ZOCO no se responsabiliza por entradas adquiridas o
            obtenidas fuera de la Plataforma, ni por los daños, perjuicios o
            inconvenientes derivados de operaciones realizadas con terceros no
            autorizados.
          </p>
        </>
      ),
    },
    {
      title: "8. CANCELACIÓN, REPROGRAMACIÓN Y REEMBOLSOS",
      body: (
        <>
          <p>
            En caso de cancelación, suspensión o reprogramación de un evento, el
            Organizador será el único y exclusivo responsable de comunicar dicha
            circunstancia a los Consumidores, así como de establecer las
            condiciones aplicables respecto de la validez de las entradas y/o los
            eventuales reembolsos.
          </p>
          <p>
            Las devoluciones, en caso de corresponder, serán gestionadas conforme
            los procedimientos y condiciones definidos y publicados por el
            Organizador. ZOCO podrá, en su carácter de proveedor tecnológico y, en
            su caso, de intermediario en la gestión de cobros, colaborar en la
            instrumentación técnica del proceso de devolución, sin asumir
            responsabilidad alguna respecto de su procedencia, alcance o
            ejecución.
          </p>
          <p>
            Los cargos por servicio y/o costos administrativos percibidos por
            ZOCO no serán reembolsables, salvo que el Organizador disponga
            expresamente lo contrario o así lo exija la normativa aplicable.
          </p>
        </>
      ),
    },
    {
      title: "9. DERECHO DE ARREPENTIMIENTO",
      body: (
        <>
          <p>
            Conforme al artículo 34 de la Ley N.º 24.240 de Defensa del
            Consumidor y la Resolución 424/2020, el Comprador podrá ejercer el
            derecho de arrepentimiento dentro de los diez (10) días corridos
            contados desde la fecha de compra o desde la recepción de la entrada,
            lo que ocurra último.
          </p>
          <p>
            El ejercicio de este derecho deberá realizarse mediante el “Botón de
            Arrepentimiento” disponible en la Plataforma o enviando un correo
            electrónico a info@zocoweb.com.ar, indicando:
          </p>
          <ul>
            <li>nombre y apellido del comprador,</li>
            <li>número de orden o transacción,</li>
            <li>DNI,</li>
            <li>correo electrónico registrado en la compra.</li>
          </ul>
          <p>
            Dentro de las 24 (veinticuatro) horas hábiles de recibido el pedido,
            ZOCO enviará un número de seguimiento del reclamo, permitiendo al
            Comprador verificar el estado del trámite.
          </p>
          <h3>Limitación por fecha del evento:</h3>
          <p>
            Debido a que las entradas corresponden a servicios con fecha
            determinada de ejecución (el evento), el derecho de arrepentimiento
            podrá ejercerse hasta 48 (cuarenta y ocho) horas antes del inicio del
            evento, y siempre dentro del plazo máximo de diez (10) días corridos
            desde la compra, lo que ocurra primero.
          </p>
          <p>
            Transcurrido cualquiera de dichos plazos, el Comprador no podrá
            ejercer el derecho de arrepentimiento, aun cuando el evento aún no se
            haya realizado.
          </p>
          <p>
            El reintegro se efectuará por el mismo medio de pago utilizado, dentro
            de los plazos operativos previstos por las entidades intervinientes.
          </p>
          <p>
            El derecho de arrepentimiento no será aplicable cuando el evento se
            haya realizado o la entrada haya sido utilizada.
          </p>
        </>
      ),
    },
    {
      title: "10. TRANSFERENCIA DE ENTRADAS",
      body: (
        <>
          <p>
            Las entradas emitidas por la Plataforma son digitales, personales y
            asociadas a un código QR único, vinculado a un usuario registrado.
          </p>
          <p>
            Sin embargo, la Plataforma permite la transferencia de entradas a
            otro usuario conforme a las siguientes condiciones:
          </p>
          <ul>
            <li>Cada entrada podrá ser transferida una sola vez (1).</li>
            <li>
              La transferencia deberá realizarse exclusivamente a través de la
              Plataforma ZOCO, utilizando la opción habilitada para tal fin.
            </li>
            <li>
              El nuevo adquirente deberá registrarse previamente en la Plataforma
              para recibir la entrada en su cuenta personal.
            </li>
            <li>
              En caso de que ya posea una cuenta activa, bastará con iniciar
              sesión para visualizar la entrada transferida.
            </li>
          </ul>
          <p>
            Una vez realizada la transferencia, esta quedará registrada
            digitalmente en el sistema y será definitiva e irreversible.
          </p>
          <p>
            Las entradas transferidas no podrán ser objeto del derecho de
            arrepentimiento, dado que el acto de transferencia se considera
            oneroso entre particulares.
          </p>
          <p>
            ZOCO no interviene ni asume responsabilidad alguna respecto de la
            relación entre el transferente y el adquirente.
          </p>
        </>
      ),
    },
    {
      title: "11. USO ADECUADO DE LA PLATAFORMA",
      body: (
        <>
          <p>El usuario se compromete a:</p>
          <ul>
            <li>no manipular ni revender entradas fuera de los canales autorizados;</li>
            <li>no utilizar información falsa o de terceros sin autorización;</li>
            <li>no interferir en el funcionamiento técnico de la Plataforma.</li>
          </ul>
          <p>
            ZOCO podrá suspender o cancelar el acceso de usuarios que incumplan
            estas disposiciones.
          </p>
        </>
      ),
    },
    {
      title: "12. PROTECCIÓN DE DATOS PERSONALES",
      body: (
        <>
          <p>
            Al aceptar los presentes Términos y Condiciones y utilizar la
            Plataforma, el Usuario declara haber leído y aceptado la Política de
            Privacidad de ZOCO vigente al momento del uso, la cual forma parte
            integrante de los presentes Términos.
          </p>
          <p>
            ZOCO tratará los datos personales de los Usuarios conforme a la Ley
            N.º 25.326 de Protección de Datos Personales, su normativa
            reglamentaria y complementaria, actuando en carácter de responsable
            del tratamiento respecto de la información recabada a través de la
            Plataforma, sin perjuicio de las comunicaciones de datos que
            correspondan a los Organizadores en el marco de la intermediación del
            servicio.
          </p>
          <p>
            La Política de Privacidad completa se encuentra disponible en:
            <br />
            <span>🔗 </span>
            <a href="https://www.zocotickets.com/privacypolicy">
              https://www.zocotickets.com/privacypolicy
            </a>
          </p>
          <p>
            El titular de los datos podrá ejercer los derechos de acceso,
            rectificación, actualización y supresión mediante solicitud dirigida a
            info@zocoweb.com.ar, en los términos de la normativa vigente.
          </p>
        </>
      ),
    },
    {
      title: "13. AUTORIZACIÓN DE USO DE IMAGEN",
      body: (
        <>
          <p>
            El Usuario, así como cualquier asistente al evento que adquiera una
            entrada a través de la Plataforma, reconoce que durante el desarrollo
            del espectáculo podrán realizarse registros fotográficos y/o
            audiovisuales de carácter general con fines de difusión, comunicación
            y promoción del evento y/o de la Plataforma.
          </p>
          <p>
            En tal sentido, al aceptar los presentes Términos y Condiciones y
            asistir al evento, el Usuario presta su consentimiento en los términos
            del artículo 53 del Código Civil y Comercial de la Nación y del
            artículo 31 de la Ley N.º 11.723 para que su imagen pueda ser captada
            en forma accesoria o incidental en el marco de tomas generales del
            evento y utilizada por ZOCO y/o por el Organizador con fines
            institucionales, promocionales y de difusión del espectáculo, en
            cualquier medio y formato, sin derecho a compensación económica
            alguna.
          </p>
          <p>
            La presente autorización no implica cesión exclusiva ni habilita el
            uso individualizado de la imagen del asistente con fines comerciales
            directos o publicitarios personalizados sin su consentimiento expreso.
          </p>
        </>
      ),
    },
    {
      title: "14. LIMITACIÓN DE RESPONSABILIDAD",
      body: (
        <>
          <p>ZOCO no será responsable por:</p>
          <ul>
            <li>cancelaciones, reprogramaciones o modificaciones de los eventos;</li>
            <li>fallas técnicas ajenas a su control;</li>
            <li>uso indebido de entradas o códigos QR;</li>
            <li>
              daños o perjuicios derivados de actos u omisiones de los
              Organizadores o de terceros.
            </li>
          </ul>
          <p>
            El uso de la Plataforma se realiza bajo exclusiva responsabilidad del
            usuario.
          </p>
        </>
      ),
    },
    {
      title: "15. MODIFICACIONES",
      body: (
        <>
          <p>
            ZOCO podrá modificar estos Términos y Condiciones en cualquier
            momento, publicando la versión actualizada en la Plataforma.
          </p>
          <p>Las modificaciones entrarán en vigencia desde su publicación.</p>
        </>
      ),
    },
    {
      title: "16. LEY APLICABLE Y JURISDICCIÓN",
      body: (
        <>
          <p>
            Estos Términos se rigen por las leyes de la República Argentina.
          </p>
          <p>
            Toda controversia será sometida a los tribunales ordinarios de la
            Ciudad de San Miguel de Tucumán, con renuncia expresa a cualquier
            otro fuero o jurisdicción.
          </p>
        </>
      ),
    },
    {
      title: "17. CONTACTO",
      body: (
        <>
          <p>
            Para consultas, reclamos o ejercicio de derechos, los usuarios podrán
            comunicarse con:
          </p>
          <div className="terms-contact">
            <div className="terms-contact-item">
              <span className="terms-contact-label">📧 Email</span>
              <a href="mailto:info@zocoweb.com.ar" className="terms-contact-value">
                info@zocoweb.com.ar
              </a>
            </div>
            <div className="terms-contact-item">
              <span className="terms-contact-label">🌐 Web</span>
              <span className="terms-contact-value">web.</span>
            </div>
          </div>
        </>
      ),
    },
  ];

  const reservationSections = [
    {
      title: "1. OBJETO",
      body: (
        <>
          <p>
            Los presentes Términos y Condiciones regulan el acceso y utilización
            del servicio de Reserva de Mesas ofrecido a través de la plataforma
            administrada por ZOCO S.A.S. (en adelante, "ZOCO").
          </p>
          <p>
            Mediante este servicio, los usuarios podrán efectuar reservas en
            establecimientos gastronómicos, bares, restaurantes, clubes,
            espacios recreativos y demás comercios adheridos (en adelante, el
            "ESTABLECIMIENTO").
          </p>
          <p>
            La utilización del servicio implica la aceptación plena, expresa e
            incondicionada de los presentes Términos y Condiciones.
          </p>
        </>
      ),
    },
    {
      title: "2. NATURALEZA DEL SERVICIO",
      body: (
        <>
          <p>
            ZOCO actúa exclusivamente como proveedor de una plataforma
            tecnológica que permite gestionar reservas entre los usuarios y los
            ESTABLECIMIENTOS.
          </p>
          <p>
            ZOCO no presta servicios gastronómicos, comerciales, recreativos ni
            de ninguna otra naturaleza ofrecidos por los ESTABLECIMIENTOS, ni
            interviene en la relación comercial existente entre éstos y los
            usuarios.
          </p>
          <p>
            Cada ESTABLECIMIENTO es el único responsable de la disponibilidad de
            mesas, de los servicios ofrecidos y del cumplimiento de las
            condiciones informadas al usuario.
          </p>
        </>
      ),
    },
    {
      title: "3. SOLICITUD DE RESERVAS",
      body: (
        <>
          <p>
            El usuario podrá efectuar reservas conforme la disponibilidad,
            plazos y condiciones establecidos por cada ESTABLECIMIENTO, los
            cuales serán informados previamente al momento de realizar la
            reserva.
          </p>
          <p>
            Para efectuar una reserva, el usuario deberá completar la
            información requerida por la plataforma.
          </p>
          <p>
            La reserva quedará confirmada una vez finalizado el proceso
            correspondiente y, cuando así lo requiera el ESTABLECIMIENTO, una
            vez acreditado el pago de la seña, anticipo o cualquier otro
            importe solicitado.
          </p>
          <p>
            El usuario declara que los datos proporcionados son completos,
            veraces y actualizados, siendo responsable por la exactitud de la
            información suministrada.
          </p>
        </>
      ),
    },
    {
      title: "4. CONDICIONES DE LA RESERVA",
      body: (
        <>
          <p>
            Cada ESTABLECIMIENTO determinará las condiciones aplicables a sus
            reservas, incluyendo, entre otras:
          </p>
          <ul>
            <li>horarios disponibles;</li>
            <li>cantidad máxima de personas;</li>
            <li>tiempo de tolerancia;</li>
            <li>requisitos de ingreso;</li>
            <li>importe de señas o anticipos, cuando corresponda;</li>
            <li>
              cualquier otra condición vinculada a la prestación del servicio.
            </li>
          </ul>
          <p>
            Dichas condiciones serán informadas al usuario antes de confirmar la
            reserva.
          </p>
        </>
      ),
    },
    {
      title: "5. CANCELACIÓN DE RESERVAS",
      body: (
        <>
          <p>
            Cuando el ESTABLECIMIENTO haya habilitado la funcionalidad de
            cancelación desde la plataforma, el usuario podrá cancelar su
            reserva sin cargo hasta veinticuatro (24) horas antes del horario
            previsto.
          </p>
          <p>
            Si la reserva hubiera requerido el pago de una seña, anticipo o
            cualquier otro importe, las condiciones de devolución serán las
            informadas por el ESTABLECIMIENTO al momento de la reserva y la
            normativa aplicable.
          </p>
          <p>
            Las devoluciones de importes serán de exclusiva responsabilidad del
            ESTABLECIMIENTO.
          </p>
        </>
      ),
    },
    {
      title: "6. INASISTENCIA",
      body: (
        <>
          <p>
            El usuario se compromete a presentarse en el ESTABLECIMIENTO en la
            fecha y horario reservados.
          </p>
          <p>
            La inasistencia podrá generar las consecuencias previstas en las
            condiciones particulares informadas por el ESTABLECIMIENTO,
            incluyendo la pérdida de la seña cuando ello hubiera sido
            expresamente informado.
          </p>
        </>
      ),
    },
    {
      title: "7. RESERVAS SUJETAS A PAGO",
      body: (
        <>
          <p>
            El ESTABLECIMIENTO podrá requerir el pago de una seña, anticipo,
            consumo mínimo, derecho de reserva u otro importe para confirmar la
            reserva.
          </p>
          <p>
            El usuario abonará exactamente el importe informado por el
            ESTABLECIMIENTO.
          </p>
          <p>
            ZOCO no adiciona cargos por servicio, reserva o utilización de la
            plataforma al usuario.
          </p>
        </>
      ),
    },
    {
      title: "8. PROCESAMIENTO DE PAGOS",
      body: (
        <>
          <p>
            Cuando el ESTABLECIMIENTO opte por cobrar anticipadamente la
            reserva mediante ZOCO, el procesamiento del pago se regirá por los
            Términos y Condiciones Generales de ZOCO Servicios de Pagos.
          </p>
          <p>
            Las comisiones y costos asociados al procesamiento del pago serán
            exclusivamente a cargo del ESTABLECIMIENTO.
          </p>
        </>
      ),
    },
    {
      title: "9. DEVOLUCIONES",
      body: (
        <>
          <p>
            Cuando corresponda la devolución total o parcial de importes
            abonados por el usuario, la misma será responsabilidad exclusiva
            del ESTABLECIMIENTO, conforme las condiciones informadas al momento
            de la reserva y la normativa aplicable.
          </p>
          <p>
            ZOCO no decide sobre la procedencia de devoluciones, reintegros o
            retenciones de importes, ni interviene en las controversias que
            pudieran suscitarse entre el usuario y el ESTABLECIMIENTO.
          </p>
        </>
      ),
    },
    {
      title: "10. RESPONSABILIDAD DEL ESTABLECIMIENTO",
      body: (
        <>
          <p>El ESTABLECIMIENTO será el único responsable por:</p>
          <ul>
            <li>la disponibilidad de mesas;</li>
            <li>la prestación de los servicios ofrecidos;</li>
            <li>la atención brindada al usuario;</li>
            <li>el cumplimiento de las reservas aceptadas;</li>
            <li>las políticas de cancelación y devolución;</li>
            <li>la calidad de los productos y servicios ofrecidos.</li>
          </ul>
        </>
      ),
    },
    {
      title: "11. LIMITACIÓN DE RESPONSABILIDAD DE ZOCO",
      body: (
        <>
          <p>ZOCO no será responsable por:</p>
          <ul>
            <li>la cancelación de reservas por parte del ESTABLECIMIENTO;</li>
            <li>la falta de disponibilidad de mesas;</li>
            <li>demoras en la atención;</li>
            <li>modificaciones de horarios;</li>
            <li>la calidad de los productos o servicios ofrecidos;</li>
            <li>incumplimientos del ESTABLECIMIENTO;</li>
            <li>devoluciones, reintegros o pérdida de señas;</li>
            <li>
              conflictos surgidos entre el usuario y el ESTABLECIMIENTO.
            </li>
          </ul>
          <p>
            La responsabilidad de ZOCO se limita exclusivamente a la provisión
            y funcionamiento de la plataforma tecnológica y, cuando
            corresponda, al procesamiento de pagos conforme a sus Términos y
            Condiciones Generales.
          </p>
        </>
      ),
    },
    {
      title: "12. DISPONIBILIDAD",
      body: (
        <>
          <p>
            ZOCO procurará mantener la plataforma disponible y en adecuado
            funcionamiento. No obstante, podrán producirse interrupciones
            temporales por tareas de mantenimiento, actualizaciones, mejoras,
            incidentes técnicos o causas ajenas a su control.
          </p>
        </>
      ),
    },
    {
      title: "13. CANALES DE ATENCIÓN",
      body: (
        <>
          <p>
            Las consultas relacionadas con el funcionamiento de la plataforma
            podrán realizarse a través de los canales de atención informados en
            el sitio web oficial de ZOCO.
          </p>
          <p>
            Las consultas vinculadas con reservas, disponibilidad de mesas,
            cancelaciones, devoluciones, atención en el establecimiento o
            cualquier aspecto relacionado con el servicio contratado deberán
            dirigirse al ESTABLECIMIENTO correspondiente.
          </p>
        </>
      ),
    },
    {
      title: "14. PROPIEDAD INTELECTUAL",
      body: (
        <>
          <p>
            La plataforma, sus funcionalidades, software, diseños, marcas,
            logotipos y demás elementos asociados son propiedad exclusiva de
            ZOCO S.A.S. o de sus licenciantes.
          </p>
          <p>
            Queda prohibida su reproducción, utilización o explotación sin
            autorización previa y por escrito de ZOCO.
          </p>
        </>
      ),
    },
    {
      title: "15. MODIFICACIONES",
      body: (
        <>
          <p>
            ZOCO podrá modificar los presentes Términos y Condiciones mediante
            su publicación en la plataforma.
          </p>
          <p>
            La utilización posterior del servicio implicará la aceptación de
            las modificaciones efectuadas.
          </p>
        </>
      ),
    },
    {
      title: "16. LEY APLICABLE Y JURISDICCIÓN",
      body: (
        <>
          <p>
            Los presentes Términos y Condiciones se regirán por las leyes de la
            República Argentina.
          </p>
          <p>
            Toda controversia derivada de su interpretación, aplicación o
            cumplimiento será sometida a la jurisdicción de los tribunales
            competentes conforme a la legislación vigente en materia de defensa
            del consumidor.
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="terms-page">
      <header className="terms-hero">
        <div className="terms-hero-inner pading150">
          <span className="terms-pill">Plataforma Ticketera ZOCO</span>
          <h1 className="terms-title">Términos y Condiciones de Uso</h1>
          <p className="terms-subtitle">
            TÉRMINOS Y CONDICIONES DE USO DE LA PLATAFORMA TICKETERA ZOCO
          </p>
          <p className="terms-subtitle">
            Incluye también los términos aplicables al módulo de reserva de
            mesas.
          </p>
        </div>
      </header>

      <div className="terms-content pading150">
        <div className="terms-stack">
          <div className="terms-card">
            {sections.map((section, index) => (
              <section
                key={section.title}
                className="terms-section"
                style={{ "--section-index": index }}
              >
                <h2>{section.title}</h2>
                {section.body}
              </section>
            ))}
          </div>

          <div className="terms-card terms-card-secondary">
            <div className="terms-module-head">
              <span className="terms-module-pill">Módulo de reservas</span>
              <h2>
                Términos y Condiciones de Uso del Módulo de Reserva de Mesas
              </h2>
              <p>
                Aplicables a las reservas realizadas en bares, restaurantes,
                clubes, espacios recreativos y demás establecimientos adheridos
                a ZOCO.
              </p>
            </div>

            <div className="terms-module-chapters">
              <span>Capítulo I · Disposiciones Generales</span>
              <span>Capítulo II · Reservas</span>
              <span>Capítulo III · Reservas Pagas</span>
              <span>Capítulo IV · Responsabilidades</span>
              <span>Capítulo V · Disponibilidad y Soporte</span>
              <span>Capítulo VI · Propiedad Intelectual</span>
              <span>Capítulo VII · Modificaciones y Jurisdicción</span>
            </div>

            {reservationSections.map((section, index) => (
              <section
                key={section.title}
                className="terms-section"
                style={{ "--section-index": sections.length + index }}
              >
                <h2>{section.title}</h2>
                {section.body}
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
